import { render } from "./Recommended.vue?vue&type=template&id=d1f0a84a"
import script from "./Recommended.vue?vue&type=script&lang=js"
export * from "./Recommended.vue?vue&type=script&lang=js"

import exportComponent from "E:\\www_spf_delivery_thai\\@Developing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__